export default __webpack_public_path__ + "static/media/sort-solid.ae0762ec.svg";